export * from './photo-card-variant-c.component';
export * from './photo-card-variant-c.module';
